"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CustomCard = _ref => {
  let {
    titleFirst = true,
    cardContainerClassName,
    titleClassName,
    titleContent,
    imageClassName,
    imageProps,
    onMouseDown = () => {},
    onMouseUp = () => {}
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "card-container",
    tabIndex: 0
  }, titleFirst ? /*#__PURE__*/_react.default.createElement("div", {
    className: cardContainerClassName,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: titleClassName
  }, titleContent), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Image, {
    fluid: true,
    src: imageProps.src,
    className: imageClassName
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: cardContainerClassName,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Image, {
    fluid: true,
    src: imageProps.src,
    className: imageClassName
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: titleClassName
  }, titleContent)));
};
var _default = exports.default = CustomCard;